import { ApiResourceFactory } from '../api.resource.factory'
import { MeasurementsRequestModel, ActionPacketModel, EntityModel, GridModel, GridRequestModel, GridRequestReferenceModel, FileModel, ActionModel, ResponseListModel, ResponseDeleteModel } from '../api.models'
import { CommonHelper } from '../../../helpers/common-helper'

export interface IActionsService {
    getActions(req: GridRequestModel, state?: any): ng.IPromise<GridModel>
    createAction(req): ng.IPromise<ActionModel>
    getAction(id, state?: any): ng.IPromise<ActionModel>
    getActionToEdit(id, state?: any): ng.IPromise<EntityModel>
    deleteAction(id): ng.IPromise<ResponseDeleteModel>
    getPackets(id, state?: any): ng.IPromise<ResponseListModel<ActionPacketModel>>
    checkActionStatus(ids, state?: any): ng.IPromise<GridModel>
}

export class ActionsService implements IActionsService {
    constructor(private apiResource: ApiResourceFactory) {

    }

    getActions(req: GridRequestModel, state: any = {}) {
        var get = this.apiResource.actions.query
        state.request = get(req)
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    createAction(req): ng.IPromise<ActionModel> {
        var save = this.apiResource.actions.save
        return save(req).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    getPackets(id, state: any = {}) {
        var getPackets: ng.resource.IResourceMethod<ng.resource.IResource<ResponseListModel<ActionPacketModel>>> = this.apiResource.actions['getPackets']
        state.request = getPackets({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getAction(id, state?: any) {
        var get = this.apiResource.actions.get
        state.request = get({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state, false, rej.data.Message))
    }

    getActionToEdit(id, state?: any) {
        var get = this.apiResource.actions['getActionToEdit']
        state.request = get({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    deleteAction(id): ng.IPromise<ResponseDeleteModel> {
        var del = this.apiResource.actions.delete
        return del({ id: id }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }
    checkActionStatus(ids, state: any = {}) {
        var post = this.apiResource.actions['checkActionStatus']
        state.request = post(ids)
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => {
            CommonHelper.handleRejection(this.apiResource, rej.status)
        })
    }
}
